import React, { useMemo } from "react";
import { css, Theme, useTheme } from "@emotion/react";
import { isEmpty } from "lodash";

import useBreakpoint from "core/hooks/useBreakpoint";
import SectionContainer from "core/Components/SectionContainer";
import MainSection from "elements/Components/BannerWithExtendedProfile/components/MainSection";
import ProfileSection from "elements/Components/BannerWithExtendedProfile/components/ProfileSection";

type Props = {
    data: BannerWithExtendedProfile,
    isUsingAltDesign?: boolean,
};

const BannerWithExtendedProfile: React.FC<Props> = ({ data, isUsingAltDesign = false }) => {
    const theme: Theme = useTheme();
    const { minWidth } = useBreakpoint();

    const [mainBannerHeight, buttonHeight] = useMemo(() => {
        switch (true) {
            case minWidth >= theme.breakpoints.sizes["4xl"]:
                return [840, 70];
            case minWidth >= theme.breakpoints.sizes["3xl"]:
                return [700, 70];
            case minWidth >= theme.breakpoints.sizes["xxl"]:
                return [560, 70];
            case minWidth >= theme.breakpoints.sizes["xl"]:
                return [489, 70];
            case minWidth >= theme.breakpoints.sizes["lg"]:
                return [490, 70];
            case minWidth >= theme.breakpoints.sizes["md"]:
                return [600, 70];
            default:
                return [385, 51];
        }
    }, [minWidth, theme.breakpoints.sizes]);

    const wrapperStyle = css`
        width: 100%;
        font-family: ${theme.fonts.figtree};
    `;

    return isEmpty(data.mainImage) ? null : (
        <SectionContainer overflowHidden>
            <div css={wrapperStyle}>
                <MainSection
                    data={data}
                    height={mainBannerHeight}
                    buttonHeight={buttonHeight}
                    isUsingAltDesign={isUsingAltDesign}
                />
                <ProfileSection data={data} />
            </div>
        </SectionContainer>
    );
};

export default BannerWithExtendedProfile;
